export default function UserInfo({ user }) {
    return <div className="flex items-center gap-x-2 text-md w-full mr-3">
        <div className="flex gap-x-1 items-center flex-grow">
            <img src={user?.picture} className="h-6 w-6 rounded-full" alt="Avatar" />
            <span className="font-bold shrink-0">{user?.name}</span>
            <span className="truncate">({user?.email})</span>
        </div>
    </div>
}